module.exports = __webpack_public_path__ + "img/bsc.510850dc.svg";